import { FlowQuestion } from 'src/lib/flow/FlowQuestion';

export const noneKey = '_none_';

export const multiSelectQuestionTypes = ['multi_select', 'tile_multi_select'];

// question key for 'other' option
export const getOtherQuestionKey = (question: FlowQuestion) => `${question.key}.other`;

export const acceptOtherInput = (question: FlowQuestion) => {
  if ('accept_other_input' in question) {
    return question.accept_other_input;
  }
  return false;
};
